import { dayjs } from '../../../utils/dayjs';

export interface DiscountPeriod {
	startDate: string | Date | ReturnType<typeof dayjs> | null;
	endDate?: string | Date | ReturnType<typeof dayjs> | null;
	discountAmount: string | number | null;
	isNew?: boolean;
	originalEndDatePassed?: boolean;
}

export function getDiscountStartMinDate(discount: DiscountPeriod, today = dayjs()) {
	return !discount.isNew && discount.startDate ? dayjs.utc(discount.startDate) : today.add(1, 'day');
}

export function validateDiscountPeriods(
	discounts: DiscountPeriod[],
	childStart: string | Date,
	childEnd: string | Date | null,
	today = dayjs(),
) {
	return discounts.map((discount, index) => {
		// Completed periods are read-only. The server verifies them against stored history.
		if (!discount.isNew && discount.originalEndDatePassed) {
			return { startDate: false, endDate: false, discountAmount: false, message: '' };
		}
		const start = dayjs.utc(discount.startDate);
		const end = discount.endDate ? dayjs.utc(discount.endDate) : null;
		const previous = index > 0 ? discounts[index - 1] : null;
		const startDate =
			!discount.startDate ||
			!start.isValid() ||
			(childEnd && !start.isBefore(dayjs.utc(childEnd), 'day')) ||
			(previous && (!previous.endDate || !start.isSame(dayjs.utc(previous.endDate).add(1, 'day'), 'day')));
		const endDate =
			!!end &&
			(!end.isValid() ||
				end.isBefore(dayjs.utc(today.format('YYYY-MM-DD')), 'day') ||
				!end.isAfter(start, 'day') ||
				!end.isAfter(dayjs.utc(childStart), 'day') ||
				(childEnd && !end.isBefore(dayjs.utc(childEnd), 'day')) ||
				(previous?.endDate && !end.isAfter(dayjs.utc(previous.endDate), 'day')) ||
				index === discounts.length - 1);
		const discountAmount =
			discount.discountAmount === null || discount.discountAmount === undefined || discount.discountAmount === '';
		const prefix = `Discount ${index + 1}: `;
		let message = '';
		if (startDate) {
			message = `${prefix}start date must be within the child's dates and one day after the previous discount ends.`;
		} else if (endDate) {
			message = `${prefix}end date must be today or later, after its start date, and within the child's dates. The last discount must have no end date.`;
		} else if (discountAmount) {
			message = `${prefix}enter a discount amount.`;
		}
		return { startDate: !!startDate, endDate: !!endDate, discountAmount, message };
	});
}
